import { FileType } from '.'

export const isImportedFolderType = (type: FileType) => {
  return type === 'imported-folder' || type === 'imported-root'
}

export const isFolderType = (type: FileType) => {
  return type === 'folder' || isImportedFolderType(type)
}
